export default __webpack_public_path__ + "static/media/dreamcube.9c95f544.jpg";